import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { useUpdateAvailable, reloadForUpdate } from "../services/updateCheck";

// A slim bar at the very top of the page (in the normal flow, never floating
// over the driver app's fixed shift controls) once a newer build is live than
// the one this tab loaded. One click reloads; "Later" hides it for this tab.
export default function UpdateBanner() {
  const available = useUpdateAvailable();
  const [hidden, setHidden] = useState(false);
  if (!available || hidden) return null;
  return (
    <div className="w-full bg-blue-600 text-white text-sm px-4 py-2 flex items-center justify-center gap-3 flex-wrap">
      <RefreshCw size={15} className="shrink-0" />
      <span>A newer version of the dashboard is live.</span>
      <button
        onClick={reloadForUpdate}
        className="bg-white/15 hover:bg-white/25 rounded-lg px-3 py-1 text-xs font-bold whitespace-nowrap">
        Reload now
      </button>
      <button onClick={() => setHidden(true)} className="text-white/75 hover:text-white text-xs underline-offset-2 hover:underline">
        Later
      </button>
    </div>
  );
}
